var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStyles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 21,
  viewBox: "-583 1486 32 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m-571.7 1502.8 4.9 4.8c.7-.8 1.7-2.2 3-3.7l-4.3-4.4c-1.5 1.4-2.8 2.6-3.6 3.3zm-6 6.1c0 5-5.3 4.3-5.3 4.3s12.6 6.3 15.4-4.7l-5-4.9c-.3 0-5.1.5-5.1 5.3zm26.6-22.8c-.6-.6-3.2.9-6.1 3.6-1.7 1.5-6.3 5.7-10 9l4.1 4.3c3.2-4 7.3-9.1 8.8-11 2.6-3.2 3.6-5.5 3.2-5.9z"
})));
export default SvgIconStyles;